import $  from 'jquery';
import Reflux from 'reflux';
import FormActions from './actions';
import ErrorHandler from '../error-messages/actions';
export default class FormStore extends Reflux.Store
{
    constructor()
    {
        super();
        this.state = this.getInitialState();
        this.listenables = FormActions;
    }
    getInitialState(){
        return {
          "senderName":"",
          "senderEmail": "",
          "recipient": "",
          "pubName":" ",
          "subject":"",
          "linkURL":"",
          "contentTitle":"",
          "message":"",
          "pubDate":"",
          "toEmailId":[],
          "isCopySender": false,
          "response-messages": []
        }
    }
    onReset(){
        this.setState(this.getInitialState());
    }
    onPostFailed(error){
        console.error("EmailFailed:",error);
        if(error){
          ErrorHandler.update(["Unable to send email."])
        }
    }
    onPostCompleted(response)
    {
        this.setState({
            "response-messages": response.messages
        })
        
    }
}




// WEBPACK FOOTER //
// ./medscape_modules/email-modal/form/store.js